<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('messages.resetpassword') }}</h1>
      <div class="card__description">
        <b-form @submit.prevent="resetpassword">
          <p>{{ $t('messages.resetpassword_explanation') }}</p>
          <br />
          <b-form-group id="passwordGroup"
                        v-bind:label="$t('messages.password')+':'"
                        label-for="password"
                        :invalid-feedback="$t('errors.password')">
            <b-form-input id="password" name="password" type="password"
                          v-model.trim="form.password"
                          @input="$v.form.password.$touch"
                          :state="$v.form.password.$dirty ? !$v.form.password.$error : null"></b-form-input>
          </b-form-group>
          <b-form-group id="repeatpasswordGroup"
                        v-bind:label="$t('messages.repeatpassword')+':'"
                        label-for="repeatpassword"
                        :invalid-feedback="$t('errors.repeatpassword')">
            <b-form-input id="repeatpassword" name="repeatpassword" type="password"
                          v-model.trim="form.repeatpassword"
                          @input="$v.form.repeatpassword.$touch"
                          :state="$v.form.repeatpassword.$dirty ? !$v.form.repeatpassword.$error : null"></b-form-input>
          </b-form-group>
          <notification-button :message="$t('messages.resetpassword')" :notification="notifications.resetpassword" field="resetpassword"
                               :disabled="$v.form.$invalid"></notification-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import NotificationButton from '../components/NotificationButton'

import { notificationMixin } from '../mixin/notification'

import { userService } from '../services/user.service'

export default {
  name: 'resetpassword',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.resetpassword') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.resetpassword'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  components: { NotificationButton },
  data: function () {
    return {
      form: {},
      notifications: {
        resetpassword: null
      }
    }
  },
  mixins: [ validationMixin, notificationMixin ],
  validations: {
    form: {
      email: {
        required,
        email
      },
      token: {
        required
      },
      password: {
        required,
        minLength: minLength(6)
      },
      repeatpassword: {
        sameAs: sameAs('password')
      }
    }
  },
  methods: {
    resetpassword () {
      if (!this.$v.$invalid) {
        let input = this.$v.form.$model
        let store = this.$store
        let router = this.$router

        userService.resetPassword(input.email, input.token, input.password).then((response) => {
          userService.logout()
          router.push('/login')
          setTimeout(() => store.commit('success', 'success.resetpassword'))
        }, (response) => {
          store.commit('error', 'errors.resetpassword')
          this.sendNotification('resetpassword', 'error')
        })
      }
    }
  },
  created: function () {
    let email = this.$route.query.email
    let token = this.$route.query.token

    if (email) {
      this.form.email = email
    }
    if (token) {
      this.form.token = token
    }

    this.$root.$on('resetNotification', (notification) => {
      this.resetNotification(notification)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue